var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_5324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3026 1.8031L1.8034 10.3023C0.727991 11.3777 0.727991 13.1213 1.8034 14.1967L1.80362 14.1969C2.87903 15.2723 4.62261 15.2723 5.69801 14.1969L14.1972 5.69772C15.2726 4.62231 15.2726 2.87873 14.1972 1.80332L14.197 1.8031C13.1216 0.727697 11.378 0.727696 10.3026 1.8031Z",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.447 7.02768L8.97209 4.55281C8.58156 4.16229 7.9484 4.16229 7.55787 4.55281L4.64106 7.46962C4.25053 7.86015 4.25054 8.49331 4.64106 8.88384L7.11593 11.3587C7.50646 11.7492 8.13962 11.7492 8.53015 11.3587L11.447 8.4419C11.8375 8.05137 11.8375 7.41821 11.447 7.02768Z",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83334 6.5C7.83334 6.40795 7.90796 6.33333 8.00001 6.33333C8.09206 6.33333 8.16667 6.40795 8.16667 6.5C8.16667 6.59205 8.09206 6.66667 8.00001 6.66667C7.90796 6.66667 7.83334 6.59205 7.83334 6.5Z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 8C9.33334 7.90795 9.40796 7.83333 9.50001 7.83333C9.59206 7.83333 9.66667 7.90795 9.66667 8C9.66667 8.09205 9.59206 8.16667 9.50001 8.16667C9.40796 8.16667 9.33334 8.09205 9.33334 8Z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 8C6.33334 7.90795 6.40796 7.83333 6.5 7.83333C6.59205 7.83333 6.66667 7.90795 6.66667 8C6.66667 8.09205 6.59205 8.16667 6.5 8.16667C6.40796 8.16667 6.33334 8.09205 6.33334 8Z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 10C8.27615 10 8.50001 9.77614 8.50001 9.5C8.50001 9.22386 8.27615 9 8.00001 9C7.72387 9 7.50001 9.22386 7.50001 9.5C7.50001 9.77614 7.72387 10 8.00001 10Z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_5324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHealth);
export default __webpack_public_path__ + "static/media/icon_health.1cf507c94236cbca48fdae96d126cd0b.svg";
export { ForwardRef as ReactComponent };